import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../state/context";

import TagsLeftPanel from "../../components/tags-left-panel/tags-left-panel.component";
import useGetTags from "../../api/tags";
import TagsRightPanel from "../../components/tags-right-panel/tags-right-panel.component";

import './tags-page.styles.scss';



export default function TagsPage() {
    const { state, dispatch } = useContext(Context);
    const [activeTag, setActiveTag] = useState("");

    const getTags = useGetTags();

    useEffect(() => {
        (async () => {
            const tags = await getTags();
            dispatch({ type: 'SET_TAGS', tags: tags });
        })();
    }, []);

    useEffect(() => {
        setActiveTag(state.activeTag);
    }, [state.activeTag]);


    return (
        <div className={"container-fluid"}>
            <div className="row mt-4">
                <TagsLeftPanel />
                {activeTag && <TagsRightPanel tag={activeTag} /> }
            </div>
        </div>
    )
}
